


// Generated from io.spcfy.orders.samplemeta.enums.ExtractionKit

export type ExtractionKitKey =
  "QIAGEN_DNEASY_BLOOD_TISSUE" |
  "QIAGEN_DNEASY_POWERSOIL_PRO" |
  "NUCLEOSPIN_TISSUE_SOIL_INSECT" |
  "ZYMO_QUICK_DNA_FECAL_SOIL" |
  "PROMEGA_WIZARD_GENOMIC_DNA" |
  "QIAGEN_DNEASY_96_BLOOD_TISSUE" |
  "QIAGEN_DNEASY_POWERSOIL_PRO_96" |
  "NUCLEOMAG_SOIL_TISSUE" |
  "ZYMOBIOMICS_96_MAGBEAD" |
  "MAGMAX_MICROBIOME_ULTRA" |
  "CCDB_INSECT_EXTRACTION" |
  "FASTDNA_SPIN_SOIL" |
  "BIO_BASIC_SOIL_DNA" |
  "POWERFECAL_DNA" |
  "NUCLEOMAG_DNA_FOOD" |
  "SUREFOOD_PREP_ADVANCED" |
  "CTAB_BASED_KIT" |
  "PURELINK_PLANT_TOTAL_DNA" |
  "INNU_PREP_PLANT_DNA" |
  "PREPGEM_TISSUE_PLANT_ENV" |
  "FOODPROOF_SAMPLE_PREP" |
  "PALL_WATER_SAMPLES" |
  "PROMEGA_MAXWELL_RSC" |
  "AANDA_SOIL_WATER_DNA" |
  "ZYMO_QUICK_DNA_96" |
  "QIAGEN_DNEASY_PLANT_PRO" |
  "QIAGEN_DNEASY_PLANT_PRO_96" |
  "GENAXXON_EXTRACTION_KIT" |
  "ANIMAL_TISSUE_DNA_MINI" |
  "OTHER" |
  "EZNA_SOIL_DNA_96" |
  "EZNA_STOOL_DNA_96" |
  "MAGBIND_ENVIRONMENTAL_96" |
  "MAGBIND_PLANT_DNA_DS_96";


export interface ExtractionKitDTO {
  key: ExtractionKitKey;
  label: string;    
}


export const ExtractionKits: Record<ExtractionKitKey, ExtractionKitDTO> = {
  QIAGEN_DNEASY_BLOOD_TISSUE: { key: "QIAGEN_DNEASY_BLOOD_TISSUE", label: "Qiagen DNeasy® Blood & Tissue Kit" },
  QIAGEN_DNEASY_POWERSOIL_PRO: { key: "QIAGEN_DNEASY_POWERSOIL_PRO", label: "Qiagen DNeasy® PowerSoil Pro Kit" },
  NUCLEOSPIN_TISSUE_SOIL_INSECT: { key: "NUCLEOSPIN_TISSUE_SOIL_INSECT", label: "Macherey-Nagel NucleoSpin® Tissue / Soil / Insect" },
  ZYMO_QUICK_DNA_FECAL_SOIL: { key: "ZYMO_QUICK_DNA_FECAL_SOIL", label: "Zymo Research Quick-DNA™ Fecal/Soil Microbe Kit" },
  PROMEGA_WIZARD_GENOMIC_DNA: { key: "PROMEGA_WIZARD_GENOMIC_DNA", label: "Promega Wizard® Genomic DNA Purification Kit" },
  QIAGEN_DNEASY_96_BLOOD_TISSUE: { key: "QIAGEN_DNEASY_96_BLOOD_TISSUE", label: "Qiagen DNeasy® 96 Blood & Tissue Kit" },
  QIAGEN_DNEASY_POWERSOIL_PRO_96: { key: "QIAGEN_DNEASY_POWERSOIL_PRO_96", label: "Qiagen DNeasy® PowerSoil Pro 96 Kit" },
  NUCLEOMAG_SOIL_TISSUE: { key: "NUCLEOMAG_SOIL_TISSUE", label: "Macherey-Nagel NucleoMag® Soil / Tissue" },
  ZYMOBIOMICS_96_MAGBEAD: { key: "ZYMOBIOMICS_96_MAGBEAD", label: "ZymoBIOMICS™ 96 MagBead DNA Kit" },
  MAGMAX_MICROBIOME_ULTRA: { key: "MAGMAX_MICROBIOME_ULTRA", label: "ThermoFisher MagMAX™ Microbiome Ultra Nucleic Acid Isolation Kit" },
  CCDB_INSECT_EXTRACTION: { key: "CCDB_INSECT_EXTRACTION", label: "CCDB DNA extraction of insects" },
  FASTDNA_SPIN_SOIL: { key: "FASTDNA_SPIN_SOIL", label: "MP Biomedicals FastDNA™ SPIN Kit for Soil" },
  BIO_BASIC_SOIL_DNA: { key: "BIO_BASIC_SOIL_DNA", label: "Bio Basic Soil DNA Isolation Kit" },
  POWERFECAL_DNA: { key: "POWERFECAL_DNA", label: "Mo Bio PowerFecal® DNA Isolation Kit" },
  NUCLEOMAG_DNA_FOOD: { key: "NUCLEOMAG_DNA_FOOD", label: "NucleoMag® DNA Food (Macherey-Nagel)" },
  SUREFOOD_PREP_ADVANCED: { key: "SUREFOOD_PREP_ADVANCED", label: "SureFood® PREP Advanced Kit (R-Biopharm)" },
  CTAB_BASED_KIT: { key: "CTAB_BASED_KIT", label: "CTAB-basierte Kits (e.g., Thermo Scientific GeneJET Plant Genomic DNA Purification Kit)" },
  PURELINK_PLANT_TOTAL_DNA: { key: "PURELINK_PLANT_TOTAL_DNA", label: "Invitrogen™ PureLink™ Plant Total DNA Purification Kit" },
  INNU_PREP_PLANT_DNA: { key: "INNU_PREP_PLANT_DNA", label: "Analytik Jena innuPREP Plant DNA Kit" },
  PREPGEM_TISSUE_PLANT_ENV: { key: "PREPGEM_TISSUE_PLANT_ENV", label: "MicroGEM prepGEM™ Tissue/Plant/Environmental" },
  FOODPROOF_SAMPLE_PREP: { key: "FOODPROOF_SAMPLE_PREP", label: "Biotecon foodproof® Sample Preparation Kit II" },
  PALL_WATER_SAMPLES: { key: "PALL_WATER_SAMPLES", label: "Pall Life Sciences DNA Extraction Kit for Water Samples" },
  PROMEGA_MAXWELL_RSC: { key: "PROMEGA_MAXWELL_RSC", label: "Promega Maxwell® RSC Environmental DNA Kit" },
  AANDA_SOIL_WATER_DNA: { key: "AANDA_SOIL_WATER_DNA", label: "A&A Biotechnology Soil & Water DNA Purification Kit" },
  ZYMO_QUICK_DNA_96: { key: "ZYMO_QUICK_DNA_96", label: "Zymo Research  Quick-DNA Fecal/Soil Microbe 96 Kit" },
  QIAGEN_DNEASY_PLANT_PRO: { key: "QIAGEN_DNEASY_PLANT_PRO", label: "Qiagen DNeasy Plant Pro Kit" },
  QIAGEN_DNEASY_PLANT_PRO_96: { key: "QIAGEN_DNEASY_PLANT_PRO_96", label: "Qiagen DNeasy Plant Pro Kit 96" },
  GENAXXON_EXTRACTION_KIT: { key: "GENAXXON_EXTRACTION_KIT", label: "Genaxxon - Extraction Kit" },
  ANIMAL_TISSUE_DNA_MINI: { key: "ANIMAL_TISSUE_DNA_MINI", label: "Animal Tissue Genomic DNA Purification Mini Prep Kit" },
  OTHER: { key: "OTHER", label: "other = Freitext und Angabe von Link" },
  EZNA_SOIL_DNA_96: { key: "EZNA_SOIL_DNA_96", label: "Omega Bio-tek - E.Z.N.A.® Soil DNA Kit – 96 Well" },
  EZNA_STOOL_DNA_96: { key: "EZNA_STOOL_DNA_96", label: "Omega Bio-tek - E.Z.N.A.® Stool DNA Kit – 96 Well" },
  MAGBIND_ENVIRONMENTAL_96: { key: "MAGBIND_ENVIRONMENTAL_96", label: "Omega Bio-tek - Mag-Bind® Environmental DNA 96 Kit" },
  MAGBIND_PLANT_DNA_DS_96: { key: "MAGBIND_PLANT_DNA_DS_96", label: "Omega Bio-tek - Mag-Bind® Plant DNA DS 96 Kit" }
};
